/**
 * Contains some commonly used form layouts
 */
export const FormLayouts = {
  normal: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  },
  long: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  },
  veryLong: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 15 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
  },
};

export default FormLayouts;
